var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconHelp = function SvgIconHelp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-649 -16) translate(265 -42) translate(384 58)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 10,
    fill: "#343434",
    stroke: "#343434",
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.891,
    d: "M6.308 1.757l.905 3.678c.052.211.215.377.426.432l3.336.873c.158.041.253.203.212.362-.027.1-.103.18-.203.21L7.62 8.316c-.2.06-.354.22-.406.422l-.907 3.563c-.04.16-.202.255-.361.215-.108-.028-.192-.114-.217-.223l-.788-3.537c-.047-.212-.206-.381-.414-.441L1.053 7.312c-.157-.045-.248-.21-.202-.367.029-.102.11-.18.212-.206l3.445-.87c.218-.056.387-.23.434-.451l.787-3.652c.035-.16.193-.263.353-.228.11.024.198.109.226.22z",
    transform: "translate(7.86 7.352)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M11.707.804l.127.476c.056.21.222.373.434.425l.44.106c.112.027.181.14.154.251-.018.074-.074.132-.147.152l-.466.129c-.201.055-.358.213-.414.414l-.128.466c-.031.11-.146.176-.257.145-.073-.02-.13-.078-.147-.152l-.106-.44c-.051-.212-.214-.378-.424-.435l-.476-.126c-.111-.03-.177-.144-.148-.255.02-.074.08-.132.154-.15l.451-.105c.22-.05.392-.223.444-.443l.105-.451c.026-.112.138-.182.25-.156.075.018.134.075.154.15z",
    opacity: 0.549,
    transform: "translate(7.86 7.352)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.891,
    d: "M6.308 1.757l.905 3.678c.052.211.215.377.426.432l3.336.873c.158.041.253.203.212.362-.027.1-.103.18-.203.21L7.62 8.316c-.2.06-.354.22-.406.422l-.907 3.563c-.04.16-.202.255-.361.215-.108-.028-.192-.114-.217-.223l-.788-3.537c-.047-.212-.206-.381-.414-.441L1.053 7.312c-.157-.045-.248-.21-.202-.367.029-.102.11-.18.212-.206l3.445-.87c.218-.056.387-.23.434-.451l.787-3.652c.035-.16.193-.263.353-.228.11.024.198.109.226.22z",
    transform: "translate(7.86 7.352)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M11.707.804l.127.476c.056.21.222.373.434.425l.44.106c.112.027.181.14.154.251-.018.074-.074.132-.147.152l-.466.129c-.201.055-.358.213-.414.414l-.128.466c-.031.11-.146.176-.257.145-.073-.02-.13-.078-.147-.152l-.106-.44c-.051-.212-.214-.378-.424-.435l-.476-.126c-.111-.03-.177-.144-.148-.255.02-.074.08-.132.154-.15l.451-.105c.22-.05.392-.223.444-.443l.105-.451c.026-.112.138-.182.25-.156.075.018.134.075.154.15z",
    opacity: 0.549,
    transform: "translate(7.86 7.352)"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-help.73a792d065adc87665484848c704d8f2.svg";